import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProgressService} from '../../service/progress.service';
import {BaseModalComponent} from '../../common/modal/base-modal/base-modal.component';
import {DomSanitizer} from '@angular/platform-browser';
import {Role} from '../../model/auth/Role';

export interface ContestPaymentConfirmData {
  contestId: string;
  userId?: string;
  role?: Role;
  groupId?: string;
}

export interface ContestPaymentConfirmResultData {
  statusChanged: boolean;
}

@Component({
  selector: 'app-contest-payment-confirm-modal',
  templateUrl: './contest-payment-confirm-modal.component.html',
  styleUrls: ['./contest-payment-confirm-modal.component.scss']
})
export class ContestPaymentConfirmModalComponent extends BaseModalComponent {

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;

  contestId: string;
  userId?: string;
  role?: Role;
  groupId?: string;

  statusChanged: boolean = false;

  constructor(sanitizer: DomSanitizer,
              dialogRef: MatDialogRef<ContestPaymentConfirmModalComponent>,
              progressService: ProgressService,
              @Inject(MAT_DIALOG_DATA) data: ContestPaymentConfirmData) {
    super(dialogRef, progressService);

    this.contestId = data.contestId;
    this.userId = data.userId;
    this.groupId = data.groupId;
    this.role = data.role;
  }

  proceedAllowed(): boolean {
    return true;
  }

  proceed(): void {
    const data: ContestPaymentConfirmResultData = {
      statusChanged: this.statusChanged
    };
    this.closeModal(data);
  }

  paymentStatusChanged() {
    this.statusChanged = true;
  }
}
